module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"add-file":"Перетащите файлы сюда или нажмите, на поле"},"en":{"add-file":"Drag and drop files to here or click to upload"}}')
  delete Component.options._Ctor
}
